import { render, staticRenderFns } from "./service-list-page.vue?vue&type=template&id=9730e352&"
import script from "./service-list-page.vue?vue&type=script&lang=js&"
export * from "./service-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports